import { scaleBand, scaleLinear } from 'd3-scale'
import { axisBottom } from 'd3-axis'
import { select } from 'd3-selection'

import { emptyElement } from '../utils'
import { topSectionHeight } from './contextOverview'

export function SATScoreInHSContext(studentContext) {
  let scoreData = {
    data: [
      {
        group: 'High School',
        color: 'rgb(0, 98, 151)',
        label: '25th',
        value: studentContext.a_hs_satc_25,
      },
      {
        group: 'High School',
        color: 'rgb(0, 98, 151)',
        label: '50th',
        value: studentContext.a_hs_satc_50,
      },
      {
        group: 'High School',
        color: 'rgb(0, 98, 151)',
        label: '75th',
        value: studentContext.a_hs_satc_75,
      },
      {
        group: 'S',
        color: '#1E1E1E',
        label: 'Student',
        value: studentContext.display_score, // if display_score> a_hs_satc_75
      },
    ],
  }
  scoreData.data.sort(function (a, b) {
    return a.value - b.value
  })

  const container = document.getElementById('SATScoreInHSContext')
  emptyElement(container)

  const margin = {
    top: 50,
    right: 0,
    bottom: 40,
    left: 0,
  }

  const width = container.clientWidth - margin.left - margin.right
  const height = topSectionHeight - margin.top - margin.bottom

  let x = scaleBand()
    .domain(
      scoreData.data.map(function (d) {
        return d.label
      })
    )
    .rangeRound([0, width])
    .paddingInner(0.4)
    .paddingOuter(0.3)

  let y = scaleLinear().range([height, 0])

  let xAxis = axisBottom(x).tickSize(0)

  let svg = select('#SATScoreInHSContext')
    .append('svg')
    .attr('class', 'chart')
    .attr('width', width + margin.left + margin.right)
    .attr('height', height + margin.top + margin.bottom)
    .attr('aria-hidden', 'true')
    .append('g')
    .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

  y.domain([0, 1600])

  // svg
  //   .selectAll('bar')
  //   .data(scoreData.data)
  //   .enter()
  //   .append('rect')
  //   .attr('aria-hidden', 'true')
  //   .style('fill', '#fff')
  //   .attr('x', function (d) {
  //     return x(d.label)
  //   })
  //   .attr('width', Math.min(x.bandwidth(), 70))
  //   .attr('y', function (d) {
  //     return y(d.value) || 0
  //   })
  //   .attr('height', function (d) {
  //     return Math.max(height - (y(d.value) || 0), 0)
  //   })

  svg
    .selectAll('bar')
    .data(scoreData.data)
    .enter()
    .append('rect')
    .attr('aria-hidden', 'true')
    .style('fill', (d) => {
      return d.color
    })
    .attr('x', (d) => {
      return x(d.label)
    })
    .attr('width', x.bandwidth())
    .attr('y', (d) => {
      return y(d.value) || 0
    })
    .attr('height', (d) => {
      return Math.max(height - (y(d.value) || 0), 0)
    })

  // x axis label for each item
  svg
    .append('g')
    .attr('class', 'x axis')
    .attr('transform', 'translate(0,' + height + ')')
    .call(xAxis)
    .selectAll('text')
    // .style('text-anchor', 'end')
    // .attr('dx', '-.3em')
    .attr('dy', '1.8em')
  // .attr('transform', 'rotate(-45)')

  // Top Bar values
  svg
    .selectAll('.text')
    .data(scoreData.data)
    .enter()
    .append('text')
    .attr('aria-hidden', 'true')
    .attr('x', (d) => {
      return x(d.label) + x.bandwidth() / 2
    })
    .attr('text-anchor', 'middle')
    .attr('y', (d) => {
      return (y(d.value) || 0) - 15
    }) // y position compare to bar height
    .attr('dy', '.7em')
    .text((d) => {
      return d.value
    })
    .attr('class', (d) => {
      if (d.label === 'Student') {
        return 'context-overview-large-text'
      }
      return 'context-overview-medium-text'
    })
    .attr('transform', (d) => {
      if (d.label === 'Student') {
        return 'translate(0, -10)'
      }
      return 'translate(0,-5)'
    })
    .attr('font-weight', 900)

  if (
    parseInt(studentContext.display_score, 10) &&
    parseInt(studentContext.a_hs_satc_75, 10) &&
    parseInt(studentContext.display_score, 10) > parseInt(studentContext.a_hs_satc_75, 10)
  ) {
    const studentBar = svg.selectAll('rect').filter((d) => {
      return d.group === 'S'
    })
    const xpos = studentBar.node().getBBox().x
    const barWidth = studentBar.node().getBBox().width
    const ypos = studentBar.node().getBBox().y
    select('#SATScoreInHSContext')
      .append('div')
      .attr('class', 'chart-callout')
      .style('left', `${xpos + 0.5 * barWidth - 75}px`) // callout width is 120px
      .style('top', `${ypos - 35}px`) // add some margin & room for callout notch
      .html('Above 75th Percentile')
  }
}
